import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@hfe/max-image';
import LinearGradient from '@hfe/max-linear-gradient';
import { RecordTabType } from '../../types/shared';
import NoticeSlider from '../notice-slider';
import Sensor from '@max/mbc-sensor';
import './index.scss';
import LandmarkItem from './landmark-item';
import Button from '@hfe/max-button';
function ExploreProgress(props) {
    const { feConfig } = props;
    const { styleConfig } = feConfig ?? {};
    return <View className="city-explore-progress-card" style={{
        backgroundColor: styleConfig.backgroundColor
    }}>
      <LinearGradient colors={[styleConfig.cardStartColor, styleConfig.cardEndColor]} start={{
        x: 0,
        y: 0
    }} end={{
        x: 0,
        y: 1
    }} className="city-explore-progress-card__background"/>
      <View className="city-explore-progress-card__content-wrapper">
        <View className="city-explore-progress-card__title-wrapper">
          <Image className="city-explore-progress-card__city-img" source={{
        uri: 'https://img.meituan.net/makerjiulv/64dfa6ca2091992c588044e2e30be8e71727.png'
    }}/>
          <Text className="city-explore-progress-card__title"> 心动城市：{props.currentCityName}</Text>
        </View>
        <View className="city-explore-progress-card__landmark-row">
          {props.landmarks.map(landmark => <View key={landmark.cardId} className="city-explore-progress-card__landmark">
              <LandmarkItem landmark={landmark} onOpenLandmark={props.onOpenLandmark} feConfig={feConfig}/>
            </View>)}
        </View>
        <View className="city-explore-progress-card__progress-bar">
          <LinearGradient colors={['rgba(255, 242, 0, 0.3)', '#fff200']} start={{
        x: 0,
        y: 0
    }} end={{
        x: 1,
        y: 0
    }} className="city-explore-progress-card__progress-bar-inner" style={{
        width: `${Math.max(5, Math.min(100, Math.round(props.currentScore / props.totalScore * 100)))}%`
    }}/>
        </View>
        <View className="city-explore-progress-card__score-wrapper">
          <Text className="city-explore-progress-card__score-text">城市探索进度：{props.currentScore}</Text>
          <Text className="city-explore-progress-card__score-total">总分{props.totalScore} 分</Text>
        </View>
        <View className="city-explore-progress-card__action-row">
          <Button className="city-explore-progress-card__action-btn" onPress={() => props.onChangeTab(RecordTabType.REWARD)}>
            <Image className="city-explore-progress-card__action-btn-img" source={{
        uri: 'https://p0.meituan.net/ingee/1f1de8a19d0e348e722e417491b5ae988845.png'
    }}/>
          </Button>
          <Button className="city-explore-progress-card__action-center-btn" onPress={() => props.onInviteClick()}>
            <LinearGradient colors={['#ffe74d', '#ffdd00']} start={{
        x: 0,
        y: 0
    }} end={{
        x: 1,
        y: 0
    }} className="city-explore-progress-card__action-center-btn-background"/>
            <Sensor className="city-explore-progress-card__action-center-btn" once onAppear={props.onInviteButtonShow}>
              <Text className="city-explore-progress-card__action-center-btn-text">邀好友解锁免单</Text>
            </Sensor>
          </Button>
          <Button className="city-explore-progress-card__action-btn" onPress={() => props.onChangeTab(RecordTabType.ASSIST)}>
            <Image className="city-explore-progress-card__action-btn-img" source={{
        uri: 'https://p0.meituan.net/ingee/1e61687ce7c01e5b814aaf1ad02695928496.png'
    }}/>
          </Button>
        </View>
        <NoticeSlider activityId={props.activityId}/>
      </View>
    </View>;
}
export default memo(ExploreProgress);
